export default __webpack_public_path__ + "static/media/CelularComMaoWebExchange.84b45102.png";